// src/components/DistrictStats.js
import React, { useMemo } from 'react';
import { 
  hasSchoolProblems,
  getDistrictProblemsByType,
  calculatePublicationProblems,
  hasTimelinessProblems,
  isDateOutdatedTmRk,
  isDateOutdatedcp,
  THRESHOLDS
} from '../utils/calculations';

const DistrictStats = ({ district, allData, filters = {} }) => {
  const statistics = useMemo(() => {
    const safeData = allData || {};
    if (!safeData.dates || !Array.isArray(safeData.dates) || safeData.dates.length === 0 || !district) {
      return {
        totalSchools: 0,
        problemSchools: 0,
        totalProblems: 0
      };
    }

    const districtSchools = safeData.dates.filter(school => {
      const matches = school.РайонНаименование === district;
      return matches;
    });
    
    if (districtSchools.length === 0) {
      return {
        totalSchools: 0,
        problemSchools: 0,
        totalProblems: 0
      };
    }

    const problemSchools = districtSchools.filter(school => {
      return hasSchoolProblems(school, safeData, filters);
    }).length;

    const problemsByType = {
      'Устаревшее ТМ': districtSchools.filter(item => isDateOutdatedTmRk(item.ДатаТМ)).length,
      'Устаревшее КП': districtSchools.filter(item => isDateOutdatedcp(item.ДатаКП)).length,
      'Устаревшее РК': districtSchools.filter(item => isDateOutdatedTmRk(item.ДатаРК)).length,
      'Ошибки в меню': districtSchools.filter(school => 
        safeData.errors && Array.isArray(safeData.errors) && safeData.errors.some(error => 
          error && error.Пищеблок && error.Пищеблок.includes(school.Наименование)
        )
      ).length,
      'Низкое соответствие': districtSchools.filter(school => {
        if (!safeData.compliance || !Array.isArray(safeData.compliance)) return false;
        const schoolCompliance = safeData.compliance.filter(comp => 
          comp && comp.ПищеблокНаименование && comp.ПищеблокНаименование.includes(school.Наименование)
        );
        const avgCompliance = schoolCompliance.length > 0 ? 
          schoolCompliance.reduce((sum, item) => sum + (item.ПроцентСоблюдения || 0), 0) / schoolCompliance.length : 100;
        return avgCompliance < THRESHOLDS.COMPLIANCE_CRITICAL;
      }).length,
      'Проблемы публикации': calculatePublicationProblems(safeData, filters.month, filters.year)
        .filter(school => districtSchools.some(ds => ds.Код === school.Код)).length,
      'Низкая своевременность': districtSchools.filter(school => 
        hasTimelinessProblems(school, safeData.timeliness, THRESHOLDS.TIMELINESS_GOOD)
      ).length
    };
    
    const totalProblems = Object.values(problemsByType).reduce((sum, count) => sum + count, 0);

    return {
      totalSchools: districtSchools.length,
      problemSchools,
      totalProblems
    };
  }, [allData, district, filters]);

  const { totalSchools, problemSchools, totalProblems } = statistics;

  return (
    <div className="stats-grid" id="district-stats">
      <div className="stat-card">
        <div className="stat-label">ОУ в районе</div>
        <div className="stat-value">{totalSchools}</div>
      </div>
      <div className="stat-card">
        <div className="stat-label">ОУ с недочетами</div>
        <div className={`stat-value ${problemSchools > 0 ? 'warning' : 'success'}`}>
          {problemSchools}
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-label">Всего недочетов</div>
        <div className={`stat-value ${totalProblems > 0 ? 'error' : 'success'}`}>
          {totalProblems}
        </div>
      </div>
    </div>
  );
};

export default DistrictStats;